import {
  FlowsQuestion,
  FlowsQuestionGroup,
} from '../../../../types/FlowsTypes';

export const getHTMLIdForTag = (tag: string): string =>
  `COMPANY-SCAN_SUBJECT-OVERVIEW_HEADER_${tag.toUpperCase()}`;

export const getHTMLIdForGroup = (group: FlowsQuestionGroup): string =>
  `COMPANY-SCAN_SUBJECT-OVERVIEW_HEADER_GROUP_${group.id.toUpperCase()}`;

export const getHTMLIdForQuestion = (question: FlowsQuestion): string =>
  `COMPANY-SCAN_SUBJECT-OVERVIEW_HEADER_QUESTION_${question.id.toUpperCase()}`;

export const scrollToId = (
  groupOrQuestion: FlowsQuestionGroup | FlowsQuestion,
): void => {
  if (isFlowsQuestionGroup(groupOrQuestion)) {
    document
      .getElementById(getHTMLIdForGroup(groupOrQuestion))
      ?.scrollIntoView({
        behavior: 'smooth',
      });
  } else {
    document
      .getElementById(getHTMLIdForQuestion(groupOrQuestion))
      ?.scrollIntoView({
        behavior: 'smooth',
      });
  }
};

const isFlowsQuestionGroup = (
  groupOrQuestion: FlowsQuestionGroup | FlowsQuestion,
): groupOrQuestion is FlowsQuestionGroup =>
  Boolean((groupOrQuestion as FlowsQuestionGroup).questions);
